module.exports = __webpack_public_path__ + "resources/img/img_LYN_m_kr.c6889ec983866116981cf1d088e40139.png";